<template>
  <div>
    <!-- 第一步选择单位 -->
    <AgencyList v-if="step === 1"/>
    <!-- 第二步，选择带队教练 -->
    <StaffList ref="staffList" v-if="step === 2"/>
    <!-- 第三步，选择运动员 -->
    <ChangePlayer v-if="step === 3"/>
    <!-- <ChangeData v-if="step === 4"/> -->
    <!-- 第四步，缴纳费用 -->
    <PayJoin v-if="step === 4"/>
    <!-- 第五步，报名成功 -->
    <PaySuccess v-if="step === 5"/>
    <div class="btnContent">
      <div class="btn top20" style="width:270px;" @click="agencySign" v-if="step === 3 && matchInfo.joinType === 4 && agencyId === -1"><a-icon type="arrow-left" />{{$t('以机构名义报名参赛，重新选择机构')}}</div>
      <div class="btn top20" @click="lastStep()" v-if="step > 1 && agencyId !== -1">{{$t('上一步')}}</div>
      <div class="btn top20" @click="lastStep()" v-if="step > 3 && agencyId === -1">{{$t('上一步')}}</div>
      <div class="btn top20" @click="nextStep()" v-if="step < 3">{{$t('下一步')}}</div>
      <div class="btn top20" style="width:200px;" @click="payJoin()" v-if="step > 2 && step < 4">{{$t('检查报名状态')}}</div>
      <div class="btn top20" style="width:270px;" @click="personalSign" v-if="step === 1 && matchInfo.joinType === 4"><a-icon type="arrow-right" />{{$t('以个人身份报名参赛，进入选手报名')}}</div>
    </div>
  </div>
</template>
<script>
import store from '@/store'
import { mapState } from 'vuex'
import AgencyList from '../agency/AgencyList'
import StaffList from '../staff/StaffList'
import ChangePlayer from './ChangePlayer'
import ChangeData from './ChangeData'
import PayJoin from './PayJoin'
import PaySuccess from '../pay/PaySuccess'
export default {
  components: {
    AgencyList,
    StaffList,
    ChangePlayer,
    ChangeData,
    PayJoin,
    PaySuccess
  },
  data () {
    return {
      matchId: this.$route.query.matchId,
      programId: this.$route.query.programId,
      agencyId: Number(this.$route.query.agencyId),
      matchInfo: store.getters['match/matchInfo'],
      step: Number(this.$route.query.step) || 1
    }
  },
  computed: {
    ...mapState({
      joinAgency: state => state.join.joinAgency
    })
  },
  watch: {
    $route () {
      this.step = Number(this.$route.query.step)
      this.agencyId = Number(this.$route.query.agencyId)
    }
  },
  methods: {
    lastStep () {
      // 修改地址参数
      switch (this.step) {
      case 2:
        this.$router.push({query: {matchId: this.matchId, programId: this.programId, step: 1}})
        break
      case 3:
        if (this.matchInfo.mode === 'ONLINE') {
          this.$router.push({query: {matchId: this.matchId, programId: this.programId, step: 1}})
        } else {
          this.$router.push({query: {matchId: this.matchId, programId: this.programId, step: 2, agencyId: this.$route.query.agencyId, teamId: this.$route.query.teamId}})
        }

        break
      case 4:
        this.$router.push({query: {matchId: this.matchId, programId: this.programId, step: 3, agencyId: this.$route.query.agencyId, teamId: this.$route.query.teamId}})
        break
      case 5:
        this.$router.push({query: {matchId: this.matchId, programId: this.programId, step: 4, agencyId: this.$route.query.agencyId, teamId: this.$route.query.teamId}})
        break
      }
    },
    nextStep () {
      switch (this.step) {
      case 1:
        if (this.joinAgency.agencyId === null) {
          this.$message.error('请选择单位')
          return
        }
        // 判断是否是邀请码报名
        if (this.matchInfo.isInvite === 1) {
          this.$api.join.inviteFindCode({agencyId: this.joinAgency.agencyId, matchId: this.matchId}).then(codeRes => {
            if (codeRes.data === null && codeRes.status === 0) {
              let html = []
              let valData = {
                agencyId: this.joinAgency.agencyId,
                matchId: this.matchId,
                code: ''
              }
              let that = this
              // eslint-disable-next-line no-return-assign
              html.push(<a-input defaultValue={valData.code} onChange={(e) => valData.code = e.target.value} placeholder="请输入邀请码" />)
              this.$confirm({
                title: '请填写邀请码',
                icon: 'edit',
                type: 'info',
                okText: '提交',
                content: (html),
                onOk () {
                  if (valData.code === '') {
                    that.$message.error('请输入邀请码')
                    return true
                  }
                  that.submitInviteCode(valData)
                }
              })
            } else {
              this.$router.push({query: {matchId: this.matchId, programId: this.programId, step: 2, agencyId: this.joinAgency.agencyId, teamId: this.joinAgency.teamId}})
            }
          })
        } else if (this.matchInfo.mode === 'ONLINE') {
          this.$api.join.onlineFindCode({agencyId: this.joinAgency.agencyId, matchId: this.matchId}).then(codeRes => {
            if (codeRes.data === null && codeRes.status === 0) {
              let html = []
              let valData = {
                agencyId: this.joinAgency.agencyId,
                matchId: this.matchId,
                code: ''
              }
              let that = this
              // eslint-disable-next-line no-return-assign
              html.push(<a-input defaultValue={valData.code} onChange={(e) => valData.code = e.target.value} placeholder="请输入邀请码" />)
              this.$confirm({
                title: '请填写邀请码',
                icon: 'edit',
                type: 'info',
                okText: '提交',
                cancelText: '没有邀请码，忽略',
                content: (html),
                onOk () {
                  if (valData.code === '') {
                    that.$message.error('请输入邀请码')
                    return true
                  }
                  that.submitCode(valData)
                },
                onCancel () {
                  that.$router.push({query: {matchId: that.matchId, programId: that.programId, step: 3, agencyId: that.joinAgency.agencyId, teamId: that.joinAgency.teamId}})
                }
              })
            } else {
              this.$router.push({query: {matchId: this.matchId, programId: this.programId, step: 3, agencyId: this.joinAgency.agencyId, teamId: this.joinAgency.teamId}})
            }
          })
        } else {
          this.$router.push({query: {matchId: this.matchId, programId: this.programId, step: 2, agencyId: this.joinAgency.agencyId, teamId: this.joinAgency.teamId}})
        }
        // this.$api.join.getMatchTeam({agencyId: this.joinAgency.agencyId, programId: 0}).then(res => {
        //   if (res.data && res.status === 0) {
        //   } else {
        //     this.$message.error(res.msg)
        //   }
        // }).catch(err => {
        //   console.log(err)
        // })
        break
      // eslint-disable-next-line no-case-declarations
      case 2:
        let data = this.$refs.staffList.getChoiceCoach()
        if (data.result) {
          if (data.leaderIds !== '' && data.leaderIds !== '-1') {
            this.$api.join.LeaderStaffAddOrUpdate({staffIds: data.leaderIds, matchId: this.matchId, teamId: this.$route.query.teamId}).then(res => {
              console.log(res)
            }).catch(err => {
              console.log(err)
            })
          }
          store.commit('join/JOIN_CHANGE_COACH_ID', data.leaderIds)
          this.$router.push({query: {matchId: this.matchId, programId: this.programId, step: 3, agencyId: this.$route.query.agencyId, teamId: this.$route.query.teamId}})
        } else {
          this.$message.error(data.content)
        }
        break
      case 3:
        this.$router.push({query: {matchId: this.matchId, programId: this.programId, step: 4, agencyId: this.$route.query.agencyId, teamId: this.$route.query.teamId}})
        break
      }
    },
    payJoin () {
      this.$router.push({query: {matchId: this.matchId, programId: this.programId, step: 4, agencyId: this.$route.query.agencyId, teamId: this.$route.query.teamId}})
    },
    personalSign () {
      this.$router.push({query: {matchId: this.matchId, programId: this.programId, step: 3, agencyId: -1, teamId: -1}})
    },
    agencySign () {
      this.$router.push({query: {matchId: this.matchId, programId: this.programId, step: 1}})
    },
    submitCode (valData) {
      this.$api.join.onlineBindAgencyCode(valData).then(res => {
        if (res.status === 0) {
          this.$message.success('成功')
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    submitInviteCode (valData) {
      this.$api.join.inviteBindAgencyCode(valData).then(res => {
        if (res.status === 0) {
          this.$message.success('成功')
        } else {
          this.$message.error(res.msg)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .btnContent {
    text-align: right;
    .btn{
      color: #fff;
      width: 100px;
      height: 30px;
      line-height: 30px;
      margin: 0 auto;
      right: 250px;
      bottom: 29px;
      text-align: center;
      border-radius: 2px;
      background-color: #b80000;
      cursor:pointer;
      display: inline-block;
      margin-top: 20px;
      margin-bottom: 20px;
    }
    .top20 {
      margin-top: 20px;
    }
    .left20 {
      margin-left: 20px;
    }
    .right20 {
      margin-right: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/comm/components/join/heaveCompetition/HeaveJoin.vue